


























import Vue from 'vue'

export default abstract class Gift extends Vue {
    abstract giftOptionChanged(): void
}
